import { sortULIDs } from '../../lib/stringUtils';

interface UnreadDividerItem {
  readonly author: { readonly id: string };
  readonly sortOrder?: string;
}

/** Hides a divider that would otherwise land on a loaded tail containing only the viewer's messages. */
export function unreadDividerSortOrderForLoadedItems(
  items: readonly UnreadDividerItem[],
  markerSortOrder: string | null,
  viewerProfileId: string | null
): string | null {
  if (!markerSortOrder || !viewerProfileId) return markerSortOrder;

  const trailingOwnSortOrders = new Set<string>();
  for (let index = items.length - 1; index >= 0; index -= 1) {
    const item = items[index];
    if (!item.sortOrder) continue;
    if (item.author.id !== viewerProfileId) break;
    trailingOwnSortOrders.add(item.sortOrder);
  }

  let previousSortOrder: string | null = null;
  for (const item of items) {
    const sortOrder = item.sortOrder;
    if (!sortOrder) continue;

    const isFirstUnread =
      sortULIDs(markerSortOrder, sortOrder) < 0 &&
      (!previousSortOrder || sortULIDs(markerSortOrder, previousSortOrder) >= 0);
    if (isFirstUnread) {
      return trailingOwnSortOrders.has(sortOrder) ? null : markerSortOrder;
    }

    previousSortOrder = sortOrder;
  }

  return markerSortOrder;
}
